/**
 * signalError(label) — shared error callback for the RW-823 signal-doc
 * listeners (useDeals, useContacts, useListings, useBuyers,
 * useComplianceQueuePg). permission-denied is expected race noise during auth
 * transitions (boot, sign-out, token refresh) — silence it, warn otherwise.
 * RW-477 guard (RW-484).
 */
export const signalError = (label) => (err) => {
  if (err?.code !== 'permission-denied') {
    console.warn(`${label} signal listener error:`, err?.message);
  }
};
